import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { powerQualityCategories } from "../data/mock";
import { getIcon } from "../data/iconMap";

const PowerQualityDetail = () => {
  const { slug } = useParams();
  const category = powerQualityCategories.find((c) => c.slug === slug);

  if (!category) return <Navigate to="/power-quality" replace />;

  const Icon = getIcon(category.icon);

  return (
    <div>
      <PageHero eyebrow="Power Quality" title={category.title} subtitle={category.description} />
      <section className="px-6 pb-28">
        <div className="max-w-4xl mx-auto">
          <Link to="/power-quality" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-qcyan mb-10 transition-colors">
            <ArrowLeft size={16} /> Back to Power Quality
          </Link>
          {category.image && (
            <Reveal>
              <img
                src={category.image}
                alt={category.title}
                className="w-full rounded-2xl border border-qamber/25 mb-10 object-cover"
              />
            </Reveal>
          )}
          <Reveal>
            <GlassCard accent="amber" className="p-8 flex items-start gap-5">
              <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qamber/10 border border-qamber/25 shrink-0">
                <Icon size={26} className="text-qamber" />
              </span>
              <div className="space-y-4">
                {(category.story || [category.description]).map((para, i) => (
                  <p key={i} className="text-base text-muted-foreground leading-relaxed">{para}</p>
                ))}
              </div>
            </GlassCard>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default PowerQualityDetail;
